import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../../store';
import { ModuleKey } from '../../enums/moduleKey';
import { closeDialog, openFreeTrialDialog } from '../../purchaseSlice';
import BaseNoAccessDialog from './BaseNoAccessDialog';

export interface FreeTrialForAccessDialogProps {
  moduleKey: ModuleKey;
}

export default function FreeTrialForAccessDialog({ moduleKey }: FreeTrialForAccessDialogProps) {
  const { t } = useTranslation('Pricing');
  const { isFreeTrialForAccessDialogOpen, selectedProduct } = useAppSelector((state) => state.purchase);
  const dispatch = useAppDispatch();

  const handleStartTrial = () => {
    dispatch(closeDialog());
    dispatch(openFreeTrialDialog(selectedProduct));
  };

  return (
    <BaseNoAccessDialog
      moduleKey={moduleKey}
      isOpen={isFreeTrialForAccessDialogOpen}
      handleAccept={handleStartTrial}
      fullStory="FreeTrialForAccess"
      buttonText={t('NoAccessDialog.EnjoyFreeTrial')}
    />
  );
}
